const PAGE_TYPE = require('./pageTypeConfig');

const getId = query => (query && query.id ? query.id : null);

const getCountry = query => (query && query.country ? query.country : null);

const getYear = query => (query && query.year ? query.year : null);

const hasQuery = query => {
  const { lng, subpath, test, ...finalQuery } = query;
  const { length } = Object.keys(finalQuery);
  return length > 0;
};

const pageRouterConfig = [
  {
    path: '/',
    pageInfo: originalPath => ({
      path: originalPath,
      page_type: PAGE_TYPE.HOME,
      entity_id: null,
    }),
  },
  {
    path: '/productions',
    pageInfo: (originalPath, pathName, queryParams) => ({
      path: originalPath,
      page_type: hasQuery(queryParams) ? PAGE_TYPE.PRODUCTION_SEARCH_LIST : PAGE_TYPE.PRODUCTIONS,
      entity_id: null,
    }),
  },
  {
    path: '/productions/:id',
    pageInfo: (originalPath, pathName) => ({
      path: originalPath,
      page_type: PAGE_TYPE.PRODUCTION_DETAILS,
      entity_id: getId(pathName),
    }),
  },
  {
    path: '/productions/:id/:action',
    pageInfo: (originalPath, pathName) => ({
      path: originalPath,
      page_type: PAGE_TYPE.PRODUCTION_DETAILS,
      entity_id: getId(pathName),
    }),
  },
  {
    path: '/productions/:id/:action/:date',
    pageInfo: (originalPath, pathName) => ({
      path: originalPath,
      page_type: PAGE_TYPE.PRODUCTION_DETAILS,
      entity_id: getId(pathName),
    }),
  },
  {
    path: '/artists',
    pageInfo: (originalPath, pathName, queryParams) => ({
      path: originalPath,
      page_type: hasQuery(queryParams) ? PAGE_TYPE.ARTIST_SEARCH_LIST : PAGE_TYPE.ARTIST,
      entity_id: null,
    }),
  },
  {
    path: '/artists/:id',
    pageInfo: (originalPath, pathName) => ({
      path: originalPath,
      page_type: PAGE_TYPE.ARTIST_DETAILS,
      entity_id: getId(pathName),
    }),
  },
  {
    path: '/artists/:id/:action',
    pageInfo: (originalPath, pathName) => ({
      path: originalPath,
      page_type: PAGE_TYPE.ARTIST_DETAILS,
      entity_id: getId(pathName),
    }),
  },
  {
    path: '/managers',
    pageInfo: (originalPath, pathName, queryParams) => ({
      path: originalPath,
      page_type: hasQuery(queryParams) ? PAGE_TYPE.MANAGERS_SEARCH_LIST : PAGE_TYPE.MANAGERS,
      entity_id: null,
    }),
  },
  {
    path: '/managers/:id',
    pageInfo: (originalPath, pathName) => ({
      path: originalPath,
      page_type: PAGE_TYPE.MANAGER_DETAILS,
      entity_id: getId(pathName),
    }),
  },
  {
    path: '/companies',
    pageInfo: originalPath => ({
      path: originalPath,
      page_type: PAGE_TYPE.COMPANIES,
      entity_id: null,
    }),
  },
  {
    path: '/companies/search',
    pageInfo: originalPath => ({
      path: originalPath,
      page_type: PAGE_TYPE.COMPANIES_SEARCH_LIST,
      entity_id: null,
    }),
  },
  {
    path: '/companies/:country',
    pageInfo: (originalPath, pathName) => ({
      path: originalPath,
      page_type: PAGE_TYPE.COMPANIES_BY_COUNTRY,
      entity_id: getCountry(pathName),
    }),
  },
  {
    path: '/companies/:country/:id',
    pageInfo: (originalPath, pathName, queryParams) => ({
      path: originalPath,
      page_type: queryParams.season_id ? PAGE_TYPE.SEASONS_DETAILS : PAGE_TYPE.COMPANY_DETAILS,
      country: getCountry(pathName),
      entity_id: getId(pathName),
      season_id: queryParams.season_id ? queryParams.season_id : null,
    }),
  },
  {
    path: '/competitions',
    pageInfo: (originalPath, pathName, queryParams) => ({
      path: originalPath,
      page_type: hasQuery(queryParams) ? PAGE_TYPE.COMPETITIONS_SEARCH_LIST : PAGE_TYPE.COMPETITIONS,
      entity_id: null,
    }),
  },
  {
    path: '/competitions/:id',
    pageInfo: (originalPath, pathName) => ({
      path: originalPath,
      page_type: PAGE_TYPE.COMPETITION_DETAILS,
      entity_id: getId(pathName),
    }),
  },
  {
    path: '/intro',
    pageInfo: (originalPath, pathName) => ({
      path: originalPath,
      page_type: PAGE_TYPE.INTRO,
      entity_id: getId(pathName),
    }),
  },
  {
    path: '/pro',
    pageInfo: originalPath => ({
      path: originalPath,
      page_type: PAGE_TYPE.PRO,
      entity_id: null,
    }),
  },
  {
    path: '/proartist',
    pageInfo: originalPath => ({
      path: originalPath,
      page_type: PAGE_TYPE.PROARTIST,
      entity_id: null,
    }),
  },
  {
    path: '/proagent',
    pageInfo: originalPath => ({
      path: originalPath,
      page_type: PAGE_TYPE.PROAGENT,
      entity_id: null,
    }),
  },
  {
    path: '/contact',
    pageInfo: originalPath => ({
      path: originalPath,
      page_type: PAGE_TYPE.CONTACT,
      entity_id: null,
    }),
  },
  {
    path: '/casting',
    pageInfo: originalPath => ({
      path: originalPath,
      page_type: PAGE_TYPE.CASTING,
      entity_id: null,
    }),
  },
  {
    path: '/venues',
    pageInfo: originalPath => ({
      path: originalPath,
      page_type: PAGE_TYPE.VENUES,
      entity_id: null,
    }),
  },
  {
    path: '/venues/search',
    pageInfo: originalPath => ({
      path: originalPath,
      page_type: PAGE_TYPE.VENUES_SEARCH_LIST,
      entity_id: null,
    }),
  },
  {
    path: '/venues/:country',
    pageInfo: (originalPath, pathName) => ({
      path: originalPath,
      page_type: PAGE_TYPE.VENUES_BY_COUNTRY,
      entity_id: getCountry(pathName),
    }),
  },
  {
    path: '/venues/:country/:id',
    pageInfo: (originalPath, pathName) => ({
      path: originalPath,
      page_type: PAGE_TYPE.VENUE_DETAILS,
      entity_id: getId(pathName),
      countryId: getCountry(pathName),
    }),
  },
  {
    path: '/statistics',
    pageInfo: originalPath => ({
      path: originalPath,
      page_type: PAGE_TYPE.STATISTICS,
      entity_id: null,
    }),
  },
  {
    path: '/onthisday',
    pageInfo: originalPath => ({
      path: originalPath,
      page_type: PAGE_TYPE.ON_THESE_DAYS,
      entity_id: null,
    }),
  },
  {
    path: '/works',
    pageInfo: (originalPath, pathName, queryParams) => ({
      path: originalPath,
      page_type: hasQuery(queryParams) ? PAGE_TYPE.MUSICAL_WORK_SEARCH_LIST : PAGE_TYPE.MUSICAL_WORK,
      entity_id: null,
    }),
  },
  {
    path: '/works/:id',
    pageInfo: (originalPath, pathName) => ({
      path: originalPath,
      page_type: PAGE_TYPE.MUSICAL_WORK_DETAILS,
      entity_id: getId(pathName),
    }),
  },
  {
    path: '/composers',
    pageInfo: originalPath => ({
      path: originalPath,
      page_type: PAGE_TYPE.COMPOSERS,
      entity_id: null,
    }),
  },
  {
    path: '/composers/search',
    pageInfo: originalPath => ({
      path: originalPath,
      page_type: PAGE_TYPE.COMPOSERS_SEARCH_LIST,
      entity_id: null,
    }),
  },
  {
    path: '/composers/:id',
    pageInfo: (originalPath, pathName) => ({
      path: originalPath,
      page_type: PAGE_TYPE.COMPOSER_DETAILS,
      entity_id: getId(pathName),
    }),
  },
  {
    path: '/article',
    pageInfo: originalPath => ({
      path: originalPath,
      page_type: PAGE_TYPE.ARTICLE,
      entity_id: null,
    }),
  },
  {
    path: '/seasons',
    pageInfo: originalPath => ({
      path: originalPath,
      page_type: PAGE_TYPE.SEASONS,
      entity_id: null,
    }),
  },
  {
    path: '/seasons/:year',
    pageInfo: (originalPath, pathName) => ({
      path: originalPath,
      page_type: PAGE_TYPE.SEASONS_BY_YEAR,
      entity_id: getYear(pathName),
    }),
  },
  {
    path: '/seasons/:year/:country',
    pageInfo: (originalPath, pathName) => ({
      path: originalPath,
      page_type: PAGE_TYPE.SEASONS_BY_COUNTRY,
      entity_id: getCountry(pathName),
      year: getYear(pathName),
    }),
  },
  {
    path: '/festivals',
    pageInfo: originalPath => ({
      path: originalPath,
      page_type: PAGE_TYPE.FESTIVALS,
      entity_id: null,
    }),
  },
  {
    path: '/festivals/:year',
    pageInfo: (originalPath, pathName) => ({
      path: originalPath,
      page_type: PAGE_TYPE.FESTIVALS_BY_YEAR,
      entity_id: getYear(pathName),
    }),
  },
  {
    path: '/festivals/:year/:country',
    pageInfo: (originalPath, pathName) => ({
      path: originalPath,
      page_type: PAGE_TYPE.FESTIVALS_BY_COUNTRY,
      entity_id: getCountry(pathName),
      year: getYear(pathName),
    }),
  },
  {
    path: '/festivals/:year/:country/:id',
    pageInfo: (originalPath, pathName) => ({
      path: originalPath,
      page_type: PAGE_TYPE.FESTIVAL_DETAILS,
      entity_id: getId(pathName),
      country: getCountry(pathName),
      year: getYear(pathName),
    }),
  },
  {
    path: '/maps',
    pageInfo: originalPath => ({
      path: originalPath,
      page_type: PAGE_TYPE.MAPS,
      entity_id: null,
    }),
  },
  {
    path: '/rentals',
    pageInfo: (originalPath, pathName, queryParams) => ({
      path: originalPath,
      page_type: hasQuery(queryParams) ? PAGE_TYPE.RENTALS_SEARCH_LIST : PAGE_TYPE.RENTALS,
      entity_id: null,
    }),
  },
  {
    path: '/account-settings',
    pageInfo: originalPath => ({
      path: originalPath,
      page_type: PAGE_TYPE.SETTINGS,
      entity_id: null,
    }),
  },
  {
    path: '/login',
    pageInfo: originalPath => ({
      path: originalPath,
      page_type: PAGE_TYPE.LOGIN,
      entity_id: null,
    }),
  },
  {
    path: '/highlights',
    pageInfo: originalPath => ({
      path: originalPath,
      page_type: PAGE_TYPE.HIGHLIGHTS,
      entity_id: null,
    }),
  },
];

module.exports = pageRouterConfig;
